<template>
  <div>
    <v-list class="draggable-item small">
      <v-list-tile>
        <v-list-tile-action style="min-width: 30px;">
          <v-checkbox
            v-model="beacon.checked"
            :disabled="mode"
            hide-details
            class="ma-0 pa-0"
          />
        </v-list-tile-action>
        <v-list-tile-action style="min-width: 30px;">
          <v-icon>{{ beacon.hasOwnProperty('type') && beacon.type === "device" ? "smartphone" : "bluetooth"}}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title><div>
            <strong style="white-space: nowrap">{{ beacon.name }}</strong></div>
          </v-list-tile-title>
          <v-list-tile-sub-title  v-if="beacon.shared_apps && user.client_id !== beacon.client_id">
            <div>
              <span
                style="white-space: nowrap"
              >App: {{ `${beacon.shared_apps.filter(app => apps.includes(app.id)).slice(0, 2).map(app => app.name).join(', ')}${beacon.shared_apps.filter(app => apps.includes(app.id)).length > 2 ? '...' : ''}`}}</span>
            </div>
          </v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action v-if="beacon.shared && user.client_id !== beacon.client_id">
          <div>
            <span style="white-space: nowrap; color: blue;">Shared</span>
          </div>
        </v-list-tile-action>
        <v-list-tile-action style="min-width: 30px;">
          <v-btn icon @click="$emit('show-info', beacon)">
            <v-icon>info</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </div>
</template>


<script>
export default {
  props: ["beacon", "user", "apps", "mode"]
};
</script>

<style>
</style>